<template>
  <div class=" is-fullwidth">
    <div class="">
      <button class="button is-warning is-pulled-right mb-2" >Export to CSV</button>
    </div>
    
    <div class="notification is-info" v-if="loading == true" >Loading orders ...</div>
    <div class="notification is-warning" v-if="loading === false && filteredOrders.length == 0">
            <p>There are no orders to display</p>
        </div>

        
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="loading == false && filteredOrders.length > 0">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Order Date
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Cutting Room</th>
          <th width="160">Process</th>
          
    	</thead>
    	<tbody>
		   
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID" :class="{'has-background-danger has-text-white' : order.cutting_urgent == 1}">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
              <td><button class="button is-small is-danger" @click="markUrgent(order)" v-if="order.cutting_urgent == 0" :disabled="working===true">Urgent</button></td>
               <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.orderdate}}</td>
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td>
<select v-model="order.cutting_location_id" class="input is-small">
  <option value="0">Please select</option>
  <option v-for="location in cutting_rooms" :value="location.id" :key="location.id">{{ location.name }}</option>
  </select>

          </td>
          
          
              <td >
                  <button class="button is-small is-info" @click="processOrder(order)" :disabled="working===true" v-show="order.cutting_location_id > 0">Process</button>
              </td>
			</tr>
    	</tbody>
    </table>
    
    
    
  </div>
</template>

<script>


import OrderService from '@/services/OrderService.js';
import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
   	
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showModal: false,
      selectedOrderID: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      cutting_rooms: [],
     order_by: 'deliverydate ASC',
     limit:''
    }
  },
   methods: {
      async getOrders() {
        this.loading=true
        OrderService.getCutSewIncomingOrders(this.accessToken, this.limit, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
    
    async processOrder(order) {
        this.working = true
        
        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             cutting_location_id: order.cutting_location_id
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            //console.log(response)
            order.cutting_processed = 1
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async markUrgent(order) {
        this.working = true
        
        var order_id = order.orderID

        var formdata = { 
            _method: 'patch',
             cutting_urgent: 1
        }; 

        OrderService.updateOrder(this.accessToken, order_id, formdata)
        .then(() => {
            this.working = false
            order.cutting_urgent = 1
            //console.log(response)
        }).catch((error) => {
           alert("Something went wrong and the order has not been updated. Please reload and try again")
            console.log("Error:" + JSON.stringify(error.response.data));
            this.working = false
        });
    },
    async getRanges() {
        UtilityService.getSimpleApiData(this.accessToken, "ranges").then(
               response => this.ranges = response 
            );
      },
      async getCuttingRooms() {
        UtilityService.getSimpleApiData(this.accessToken, "locations?cutting=1").then(
               response => this.cutting_rooms = response 
            );
      },
    
  },
  computed : {
      filteredOrders: function () {
       
        let filteredOrders =  this.orders.filter(function(u) {
            if(  u.cutting_processed == 0) 
            {
              return 1
            }
          })

       

          return filteredOrders
       
     }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getCuttingRooms();
        });
  },
 
  mounted() {
    if (localStorage.cutting_incoming_order_by) {
      this.order_by = localStorage.cutting_incoming_order_by;
    }
    else{
      this.order_by = 'deliverydate ASC'
    }
      
  },
  watch: {
    'order_by'() {
      
      localStorage.cutting_incoming_order_by = this.order_by
      
    },
  }
}


</script>

